<template>
    <div class="content content--registration content--small-progress">
        <div class="small-window">
            <div class="form-wrap">
                <h1 class="form-wrap__title form-wrap__title--sticky form-wrap__title--no-progress">Ваш личный кабинет создан</h1>
                <div class="form-wrap__row">
                    <h2 class="form-wrap__text color--violet">Заполните анкету <br> для получения микрокредита. Это нужно сделать один раз — и займет не больше пяти минут.</h2>
                </div>
                <div class="form-wrap__row">
                    <router-link tag="button" class="button button--violet" :to="{name: 'PassportData'}">Продолжить заполнение</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'registrationThanks',
        metaInfo:{
            title: 'Личный кабинет создан'
        }
    }
</script>

<style lang="scss">

</style>